import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/consumer/contact-us"
    element={
      <DefaultConsumerLayout
        backgroundImage={require('../../../../assets/images/consumer/contact-us-bg.jpg')}
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'Contact us',
            item: '/consumer/contact-us',
          },
        ]}
      />
    }
  >
    <Route path="consumer/contact-us/:type?" element={<AsyncPage />} />
  </Route>
);
